<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountDetail.category== 'RENTAL_FLEET'">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
    </small>
    <small *ngIf="accountDetail.category== 'FLEET_MANAGEMENT_COMPANY' || accountDetail.category == 'MOBILITY_COMPANY' || accountDetail.category == 'FIELD_SERVICE_COMPANY'">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management&nbsp;</a>
    </small>
    <small>
      /<a [routerLink]="['/certificates']" (click)="onCloseCertificateDetail()" class="text-secondary"> Certificates</a>
    </small>
    <small *ngIf="isViewCertificateDetail">
      /<a class="text-secondary"> {{selectedProvisionedCertificate.oemCustomerId}}</a>
    </small>
  </div>
</div>

<div *ngIf="!isViewCertificateDetail" class="row pt-2 no-gutters">
  <div class="table-responsive col-12 mt-4 pb-1">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <!-- <th scope="col" width="5%" class="text-center"></th> -->
          <th scope="col">Certificate Number</th>
          <th scope="col">Certificate Name</th>
          <th scope="col">Entity ID</th>
          <th scope="col">Entity Name</th>
          <!-- <th scope="col">
            <select id="certificateStatusSelect" (change)="onFilter($event.target.value)">
              <option>Status</option>
              <option>All</option>
              <option *ngFor="let item of statusFilterOption;">
                {{item | customText}}
              </option>
            </select>
          </th> -->
          <th scope="col" class="text-center">Vehicles</th>
        </tr>
      </thead>
      <tbody class="scroll-height-screenHeight hide-x-scroll">
        <tr *ngFor="let certificate of certificates; let i = index" (click)="onCertificateSelected(certificate)">
          <!-- <th width="5%" scope="row" class="pr-0 text-center">
              <i class="fas fa-trash cursor-pointer black" (click)="onDeleteProvisionedCertificate(certificate)"></i>
            </th> -->
          <td class="cursor-pointer" class="cursor-pointer"><span
              *ngIf="certificate.oemCustomerId; else valueNotAvailable">{{certificate.oemCustomerId}}</span></td>
          <td class="cursor-pointer"><span
              *ngIf="certificate.name; else valueNotAvailable">{{certificate.name}}</span></td>
          <td class="cursor-pointer"><span
              *ngIf="accountDetail.oemCustomerId; else valueNotAvailable">{{accountDetail.oemCustomerId}}</span>
          </td>
          <td class="cursor-pointer"><span
              *ngIf="accountDetail.name; else valueNotAvailable">{{accountDetail.name}}</span></td>
          <!-- <td class="cursor-pointer"><span *ngIf="certificate.status; else valueNotAvailable">{{certificate.status |
              customText}}</span></td> -->
          <td class="text-center cursor-pointer">
            <span *ngIf="certificate.vehicles; else noVehicles">{{certificate.vehicles}}</span>
            <ng-template #noVehicles><span>0</span></ng-template>
          </td>
          <ng-template #valueNotAvailable>
            <span>-</span>
          </ng-template>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row pt-2 no-gutters" *ngIf="isViewCertificateDetail">
  <div class="col-12">
    <app-certificate-detail [certificate]="selectedProvisionedCertificate"></app-certificate-detail>
  </div>
</div>